<span *ngFor="let r of ratingValues" tappable (click)="setRating(r)">
  <ion-icon src="/assets/fontawesome/{{ rating >= r ? 'solid' : 'regular' }}/star.svg"></ion-icon>
</span>
